export default () => `
  <div>
    <div class="sub-header"><strong>NXT UMOUNT Combo Clamp:</strong> <br> 1 in gap</div>
    <div class="sub-header"><strong>NXT UMOUNT Hidden End Clamp:</strong> <br> 0 in gap</div>
  </div>
`;